import React from 'react';
import { Input, Modal } from 'antd';
import { message } from '../../utils/antdMessage';

export const DANGER_CONFIRM_PHRASE = '确认删除';

/**
 * 危险操作二次确认：必须输入指定短语后才继续。
 * @returns {Promise<string>} 确认短语（供请求体 confirm_text 使用）
 */
export function confirmDangerousAction({
  title,
  content,
  phrase = DANGER_CONFIRM_PHRASE
} = {}) {
  let typed = '';
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: title || '危险操作确认',
      okText: '确认执行',
      okType: 'danger',
      cancelText: '取消',
      content: (
        <div>
          <div style={{ marginBottom: 12 }}>{content}</div>
          <p style={{ marginBottom: 8, color: '#b45309' }}>
            请输入「{phrase}」后继续（区分大小写）：
          </p>
          <Input
            placeholder={phrase}
            onChange={(e) => { typed = e.target.value; }}
            onPressEnter={(e) => { typed = e.target.value; }}
          />
        </div>
      ),
      onOk: () => {
        if (String(typed).trim() !== phrase) {
          message.error(`请完整输入「${phrase}」`);
          return Promise.reject(new Error('confirm mismatch'));
        }
        resolve(phrase);
        return Promise.resolve();
      },
      onCancel: () => reject(new Error('cancelled'))
    });
  });
}
